import CRUDService from "../services/base/CRUDService";

export default class MaterialService extends CRUDService {

  static ALL_URL = 'integration//v1/materials/';

  getBaseURL() {
    return MaterialService.ALL_URL;
  }

  importMaterials(entity) {
    return this.getHttpRequest().post(`${MaterialService.ALL_URL}imports`, entity);
  }
}



// WEBPACK FOOTER //
// ./src/material/MaterialService.js